/** Which tabs a change to a column map entry reaches. */
export enum AssetSheetColumnMapScope {
	/** The entry's own tab only. */
	THIS_TAB = 'this_tab',
	/** Every tab mapping a column of the same name on the same axis. */
	ALL_TABS = 'all_tabs',
}
